<template>
  <div id="app">
    <notice-page></notice-page>
  </div>
</template>

<script>
// OGP タグをサーバサイドで書き出すためにAppを個別に作成
import NoticePage from '@/pages/notice/page/index.vue'

export default {
  name: 'app',
  components: {
    NoticePage
  }
}
</script>

<style src="./app.css">
</style>
